export enum HandballMissedThrowAttribute {
  ThrowWoodwork = 469,
  SixMeter = 1012,
  NineMeter = 1013,
  Air = 1014,
  Ground = 1015,
  LeftSide = 1016,
  RightSide = 1017,
  Center = 1018,
  LeftWing = 1019,
  RightWing = 1020,
  FastAttack = 1021,
  AfterTurnover = 1022,
  Pivot = 1023,
  Breakthrough = 1024,
}
